import {
  ActiveStream,
  ApiError,
  GameStream,
  GameStreamProtocol,
  StreamStatus,
} from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { Game } from "../../../models/Game";
export enum GameActionTypes {
  GAME_FETCH_REQUEST = "GAME_FETCH_REQUEST",
  GAME_FETCH_SUCCESS = "GAME_FETCH_SUCCESS",
  GAME_FETCH_ERROR = "GAME_FETCH_ERROR",

  ADD_BONUS_GAME_REQUEST = "ADD_BONUS_GAME_REQUEST",
  ADD_BONUS_GAME_SUCCESS = "ADD_BONUS_GAME_SUCCESS",
  ADD_BONUS_GAME_ERROR = "ADD_BONUS_GAME_ERROR",

  ADD_TO_FAVORITE_REQUEST = "ADD_TO_FAVORITE_REQUEST",
  ADD_TO_FAVORITE_SUCCESS = "ADD_TO_FAVORITE_SUCCESS",
  FAVORITE_ERROR = "FAVORITE_ERROR",

  REMOVE_FROM_FAVORITE_REQUEST = "REMOVE_FROM_FAVORITE_REQUEST",
  REMOVE_FROM_FAVORITE_SUCCESS = "REMOVE_FROM_FAVORITE_SUCCESS",

  BULK_REMOVE_FROM_FAVORITE_REQUEST = "BULK_REMOVE_FROM_FAVORITE_REQUEST",
  BULK_REMOVE_FROM_FAVORITE_SUCCESS = "BULK_REMOVE_FROM_FAVORITE_SUCCESS",
  BULK_REMOVE_FROM_FAVORITE_ERROR = "BULK_REMOVE_FROM_FAVORITE_ERROR",

  BULK_REMOVE_FROM_LAST_PLAYED_REQUEST = "BULK_REMOVE_FROM_LAST_PLAYED_REQUEST",
  BULK_REMOVE_FROM_LAST_PLAYED_SUCCESS = "BULK_REMOVE_FROM_LAST_PLAYED_SUCCESS",
  BULK_REMOVE_FROM_LAST_PLAYED_ERROR = "BULK_REMOVE_FROM_LAST_PLAYED_ERROR",

  PLAY = "PLAY",
  PLAY_ERROR = "PLAY_ERROR",
  PLAY_SUCCESS = "PLAY_SUCCESS",

  STOP_GAME = "STOP_GAME",
  CANCEL_GAME = "CANCEL_GAME",
  STREAM_PLAYING = "STREAM_PLAYING",

  PLAY_RESOLVE_STREAM = "PLAY_RESOLVE_STREAM",
  PLAY_RESOLVE_STREAM_ERROR = "PLAY_RESOLVE_STREAM_ERROR",
  PLAY_RESOLVE_PENDING = "PLAY_RESOLVE_PENDING",
  PLAY_RESOLVE_RUNNING = "PLAY_RESOLVE_RUNNING",
  PLAY_RESOLVE_CANCELED = "PLAY_RESOLVE_CANCELED",
  CLEAN_STREAM_RESOLVED = "CLEAN_STREAM_RESOLVED",
  STREAM_STOPPED = "STREAM_STOPPED",

  SET_VG_DESCRIPTION = "SET_VG_DESCRIPTION",
}

export type GameAction =
  | {
      type: GameActionTypes.GAME_FETCH_REQUEST;
      id: string;
    }
  | {
      type: GameActionTypes.GAME_FETCH_SUCCESS;
      game: Game;
      isFavorite: boolean;
    }
  | {
      type: GameActionTypes.GAME_FETCH_ERROR;
      id: string;
      error?: ApiError;
    }
  | {
      type: GameActionTypes.ADD_BONUS_GAME_REQUEST;
      id: string;
    }
  | {
      type: GameActionTypes.ADD_BONUS_GAME_SUCCESS;
      game: Game;
    }
  | {
      type: GameActionTypes.ADD_BONUS_GAME_ERROR;
      id: string;
      error?: ApiError;
    }
  | {
      type: GameActionTypes.ADD_TO_FAVORITE_REQUEST;
      id: string;
    }
  | {
      type: GameActionTypes.ADD_TO_FAVORITE_SUCCESS;
      id: string;
    }
  | {
      type: GameActionTypes.FAVORITE_ERROR;
      id: string;
      error?: ApiError;
    }
  | {
      type: GameActionTypes.REMOVE_FROM_FAVORITE_REQUEST;
      id: string;
    }
  | {
      type: GameActionTypes.REMOVE_FROM_FAVORITE_SUCCESS;
      id: string;
    }
  | {
      type: GameActionTypes.BULK_REMOVE_FROM_FAVORITE_REQUEST;
      ids: Set<string>;
    }
  | {
      type: GameActionTypes.BULK_REMOVE_FROM_FAVORITE_SUCCESS;
      ids: Set<string>;
    }
  | {
      type: GameActionTypes.BULK_REMOVE_FROM_FAVORITE_ERROR;
      error?: ApiError;
    }
  | {
      type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_REQUEST;
      ids: Set<string>;
    }
  | {
      type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_SUCCESS;
      ids: Set<string>;
    }
  | {
      type: GameActionTypes.BULK_REMOVE_FROM_LAST_PLAYED_ERROR;
      error?: ApiError;
    }
  | {
      type: GameActionTypes.PLAY;
      game: Game;
      protocole: GameStreamProtocol;
    }
  | {
      type: GameActionTypes.PLAY_SUCCESS;
      id: string;
    }
  | {
      type: GameActionTypes.PLAY_ERROR;
      error?: ApiError;
    }
  | {
      type: GameActionTypes.STOP_GAME;
    }
  | {
      type: GameActionTypes.CANCEL_GAME;
    }
  | {
      type: GameActionTypes.STREAM_PLAYING;
    }
  | {
      type: GameActionTypes.PLAY_RESOLVE_STREAM;
      gameStream: GameStream;
    }
  | {
      type: GameActionTypes.PLAY_RESOLVE_CANCELED;
      gameStream: GameStream;
    }
  | {
      type: GameActionTypes.PLAY_RESOLVE_STREAM_ERROR;
      code?: string;
      message: string;
    }
  | {
      type: GameActionTypes.PLAY_RESOLVE_RUNNING;
      gameStream: GameStream;
    }
  | {
      type: GameActionTypes.PLAY_RESOLVE_PENDING;
      gameStream: GameStream;
    }
  | {
      type: GameActionTypes.CLEAN_STREAM_RESOLVED;
    }
  | {
      type: GameActionTypes.STREAM_STOPPED;
    }
  | { type: GameActionTypes.SET_VG_DESCRIPTION; url: string; description: unknown };

export const favoriteError = (id: string, error?: ApiError): GameAction => ({
  type: GameActionTypes.FAVORITE_ERROR,
  id,
  error,
});

export const playSuccess = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    dispatch({ type: GameActionTypes.PLAY_SUCCESS, id });
  };
};

export const dismissFavoriteError = (id: string) => {
  return (dispatch: Dispatch<GameAction>) => {
    dispatch(favoriteError(id));
  };
};

export const resolveStream = (gameStream: GameStream): GameAction => ({
  type: GameActionTypes.PLAY_RESOLVE_STREAM,
  gameStream,
});
export const resolveStreamError = (
  code: string | undefined,
  message: string,
): GameAction => ({
  type: GameActionTypes.PLAY_RESOLVE_STREAM_ERROR,
  code,
  message,
});

export const resolveApiError = (error: ApiError): GameAction => ({
  type: GameActionTypes.PLAY_ERROR,
  error,
});

export const recoverStream = (u: ActiveStream) => {
  return (dispatch: Dispatch<GameAction>) => {
    const gameStream = {
      meta: {
        message: "Recovered",
      },
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      stream: u.stream!,
    };
    dispatch(resolveStream(gameStream));
    resolveGameStream(gameStream)(dispatch);
  };
};

export const resolveStreamRunning = (gameStream: GameStream): GameAction => ({
  type: GameActionTypes.PLAY_RESOLVE_RUNNING,
  gameStream,
});

const resolveStreamPending = (gameStream: GameStream): GameAction => ({
  type: GameActionTypes.PLAY_RESOLVE_PENDING,
  gameStream,
});

export const resolveGameStream = (gameStream: GameStream) => {
  return (dispatch: Dispatch<GameAction>) => {
    const status = gameStream.stream.status;
    switch (status) {
      case StreamStatus.Error:
        dispatch(resolveStreamError(gameStream.meta.errorCode, gameStream.meta.message));
        break;
      case StreamStatus.Running:
      case StreamStatus.Playing:
        dispatch(resolveStreamRunning(gameStream));
        playSuccess(gameStream.stream.gameId || "")(dispatch);

        break;
      case StreamStatus.Pending:
        dispatch(resolveStreamPending(gameStream));
        break;
      case StreamStatus.Cancelled:
        dispatch({ type: GameActionTypes.PLAY_RESOLVE_CANCELED, gameStream });
        break;
    }
  };
};

export const cleanGamePlayProps = () => {
  return (dispatch: Dispatch<GameAction>) => {
    dispatch({
      type: GameActionTypes.CLEAN_STREAM_RESOLVED,
    });
  };
};

export const getDeviceStreams = (streams: ActiveStream[], audid: string) => {
  return streams.filter(
    (u) =>
      u.stream && u.stream.audid === audid && u.stream.status === StreamStatus.Playing,
  );
  // return streams;
};
